<script>
  import { scale } from 'svelte/transition';
	import { quintOut } from 'svelte/easing';
  import { site } from './store.js';
  import Sites from './Sites.svelte';

  export const path = '/'

  let show_search_form = false
  let search_input;
  let menus = []

  function searchFormShow(){
    show_search_form = true
    setTimeout(() => { search_input.focus() }, 50)
  }

  function searchFormHide(){
    show_search_form = false
  }
</script>

<header id="header">
  <Sites />
  <div class="header-inner clear">
    <a id="logo" href="/" title="Sunvair Group">
      <img src="/img/sunvairgroup/logo.svg" alt="{ $site.name } Logo" style="width: 300px">
    </a>

    <a id="mobile-menu" href="javascript:showMenu();"><span></span><span class="screen-reader-text">Mobile menu</span></a>
    <div class="search-icon">

      {#if show_search_form}
        <button class="opened" on:click={searchFormHide}>
          <span class="screen-reader-text">search menu</span>
          <em class="fa fa-times" aria-hidden="true"></em>
        </button>
      {:else}
        <button on:click={searchFormShow}>
          <span class="screen-reader-text">search menu</span>
          <em class="fa fa-search" aria-hidden="true"></em>
        </button>
      {/if}

    </div>

    <nav class="main-menu">
      <div class="menu-main-menu-container">
        <ul id="menu-main-menu" class="menu">
          {#each $site.navs as nav, i}
            {#if nav.subs}
              <li
                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children"
                on:mouseover={ev => menus[i].classList.add("hover") }
                on:mouseout={ev => menus[i].classList.remove("hover") }
                bind:this={menus[i]}
              >
                <!--<a href="" class="menu-image-title-after menu-image-not-hovered"><img src="index_files/bg-sub-menu-new-01.jpg" class="menu-image menu-image-title-after" alt="" width="430" height="326"><span class="menu-image-title">{ nav.label }</span></a>-->
                <a href={ nav.url } class="menu-image-title-after menu-image-not-hovered"><span class="menu-image-title">{ nav.label }</span></a>
                <ul class="sub-menu">
                  <span style="background: url({ nav.sub_background }) no-repeat 0 50% / cover;"></span>
                  <div>
                    {#each nav.subs as sub}
                      <li class="menu-item menu-item-type-post_type menu-item-object-page"><a href={ sub.url } class="menu-image-title-after"><span class="menu-image-title">{ sub.label }</span></a></li>
                    {/each}
                  </div>
                </ul>
              </li>
            {:else}
              <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-400"><a href={nav.url} class="menu-image-title-after"><span class="menu-image-title">{ nav.label }</span></a></li>
            {/if}
          {/each}
        </ul>
      </div>
    </nav>
      {#if show_search_form}
        <form role="search" method="get" class="search-form" action="/search" transition:scale="{{duration: 400, easing: quintOut}}">
          <label for="search-form" style="display: none;">search</label>
          <div class="search-wrap">
            <input type="text" id="search-form" class="search-field ui-autocomplete-input" name="q" placeholder="Site and capability search" autocomplete="off" bind:this={search_input}>
            <button type="submit" class="search-submit"><i class="fa fa-search" aria-hidden="true"></i><span class="screen-reader-text">search button</span></button>
          </div>
          <div class="works-timing"></div>
        </form>
      {/if}
  </div>
</header>

<style>
#header {
  position: sticky;
  top: -40px;
  z-index: 999;
  background: #fff;
  /*-webkit-transform: translate(0, 40px);
  transform: translate(0, 40px);
  -webkit-transition:  -webkit-transform 0.3s;
  transition: transform 0.3s;
  */
}
#header.without-top-nav {
  -webkit-transform: translate(0, 0);
  transform: translate(0, 0);
}
.admin-bar #header,
.admin-bar .list-of-sites {
  top: 32px;
}
.fixed-menu #header {
  -webkit-transform: translate(0, 0);
  transform: translate(0, 0);
}
.fixed-menu .main-menu ul li a {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.fixed-menu .search-icon button {
  top: 2.2rem;
}
.fixed-menu #logo {
  top: calc(2rem - 12px);
}
#logo:focus {
  opacity: 0.7;
}
.fixed-menu .main-menu ul ul li a { 
  padding: 0;
}
/*navigation*/
.mobile-navi,
.close-menu {
  display: none;
}
#logo {
  float: left;
  top: calc(3rem - 12px);
  position: relative;
  -webkit-transition: top 0.3s;
  transition: top 0.3s;
  text-decoration: none;
}
#logo span {
  display: block;
  text-decoration: none;
  color: #283350;
  pointer-events: none;
  font-size: 1.3rem;
  margin-top: -1px;
  margin-right: -150px;
}
.search-icon {
  float: right;
  margin-left: .9rem;
}
.search-icon button {
  display: block;
  padding: 0;
  border: none;
  background: none;
  width: 3.5rem;
  height: 3.5rem;  
  -webkit-transition: opacity 0.35s, top 0.3s;
  transition: opacity 0.35s, top 0.3s;
  position: relative;
  top: 3rem;
  cursor: pointer;
}
.search-icon button:hover,
.search-icon button:focus {
  opacity: 0.7;
}
.search-icon button em,
.icon-wrap i {
  font-size: 22px;
  color: #0079fe;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  transition: opacity .35s, visibility .35s;
}
.icon-wrap i {
  left: auto;
  right: 0;
  top: 50%;
  -webkit-transform: translate(0%,-50%);
  transform: translate(0%,-50%);
}
.search-form {
  position: absolute;
  top: 100%;
  right: 0;
  background: #eeeeee;
  width: 100vw;
  opacity: 1;
  visibility: visible;
  transition: opacity .35s, visibility .35s;
  z-index: 9;
}
.mobile-navi .search-form {
  padding: 0;
  border: none;
  position: static;
  width: 100%;
  display: block!important;
}
.mobile-navi .search-submit {
  right: 0;
  top: 0;
}
.icon-wrap {
  width: 100%;
  max-width: 764px;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  z-index: 1;
  transform: translate(-50%,0);
}
.icon-wrap i {
  float: right;
}
.mobile-navi .icon-wrap {
  display: none;
}
.search-wrap {
  width: 100%;
  max-width: 764px;
  margin: 0 auto;
  position: relative;
}
.search-wrap .search-submit {
  position: absolute;
  right: 0;
  opacity: 1;
  visibility: visible;
  z-index: 2;    
}
.search-form .search-field {
  color: #777;
  font-size: 3.5rem;
  line-height: 4.1rem;
  font-family: Roboto;
  font-weight: 300;
  padding: 1.9rem 2.9rem; 
  background: none;
  width: 100%;
  max-width: 764px;
  margin: 0 auto;
  display: block;
  box-sizing: border-box;
  border: none;
  -webkit-appearance: none;
  border-radius: 0;
  border: none;
  outline: 0;
  position: relative;
  z-index: 2
}
.search-submit {
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
  width: 1px;
  height: 1px;
  font-size: 18px;
  color: #167efa;
  cursor: pointer;
  border: none;
  background: transparent;
  visibility: hidden;
  opacity: 0;
}

.main-menu {
  float: right;
}
.main-menu.to-hide:after {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	top: 0;
	content: '';
	z-index: 9999;
}
.main-menu ul {
  list-style-type: none;
}
.main-menu ul li {
  display: inline-block;
  vertical-align: top;
  font-size: 2rem;
  line-height: 2.4rem;
  position: relative;
  z-index: 999;
  font-family: 'Khand', Arial, sans-serif;
}
.main-menu ul li a {
  display: block;
  color: #062952;
  position: relative;
  padding: 3.7rem 3.9rem 3.9rem;
  text-decoration: none;
  -webkit-transition: color 0.35s, padding 0.3s;
  transition: color 0.35s, padding 0.3s;
  letter-spacing: 2px;
}
.main-menu ul li .menu-image {
  display: none;
}
.main-menu .menu-top-container > ul > li:hover > a,
.main-menu .menu-top-container > ul > li:focus > a {
  color: #00a5ff;
}
/*.is-desktop .main-menu ul li.hover a:before,
.is-desktop .main-menu ul li a:focus:before {
  width: 100%;  
}*/
.main-menu ul li.menu-item-has-children a span {
  padding-right: 15px;
  position: relative;
}
.main-menu ul li.menu-item-has-children > a > span:after { 
  content: "";
  position: absolute;
  border-right: 1px solid #062952;
  border-bottom: 1px solid #062952;
  width: 4px;
  height: 4px;
  right: 0;
  top: 50%;
  margin-top: -5px;
  transform: rotate(45deg);
}
.main-menu ul li.menu-item-has-children.hover a span:after
.main-menu ul li.menu-item-has-children a:focus span:after  {
  margin-top: -2px;
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
} 

.header-inner {
  position: relative;
  padding: 0 3.6rem 0 3.7rem;
}
.main-menu ul ul {
  padding: 4rem 0 ;
  position: absolute;
  top: 100%;
  left: -37.8rem;
  margin-left: 3.5rem;
  min-width: 62.5rem;
  box-sizing: border-box;
  padding-left: 36.2rem;
  -webkit-transform: translate(0, -4rem);
  transform: translate(0, -4rem);
  -webkit-transition: -webkit-transform 0.35s, opacity 0.35s, visibility 0.7s;
  transition: transform 0.7s, opacity 0.35s, visibility 0.35s;
  visibility: hidden;
  opacity: 0;
  z-index: 999;
  box-sizing: border-box;
  height: auto!important;
  border-top: 0.6rem solid #00a9fe;
  background: #132c4a;
}
.main-menu ul ul > span {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	width: 36.2rem;
}
.main-menu ul ul > span:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: linear-gradient(to left, #132c4a 5%, transparent 100%);
}
.main-menu ul ul div {
  position: static;
  top: 50%;
  left: 0;
  right: 0;
}

.main-menu ul li.hover ul,
.is-desktop .main-menu ul li > a:focus + ul,
.is-desktop .main-menu ul li ul.focused  {
  -webkit-transform: translate(0, 0);
  transform: translate(0, 0);
  visibility: visible;
  opacity: 1;
}
.main-menu ul ul li {
  display: block;
  margin-bottom: 2.5rem;
}
.main-menu ul ul li:last-child {
  margin-bottom: 0;
}
.main-menu ul ul li a {
  color: #fff;
  padding: 0;
  display: inline-block;
}
.main-menu ul ul li a:before {
  display: none;
}
.main-menu ul ul li a:hover,
.main-menu ul ul li a:focus {
  text-decoration: underline;
  color: #00a5ff;
}

</style>
